module.exports = __webpack_public_path__ + "d664201f/img/share-icon.0f8a11b4.svg";